// Photo Swipe Gallery Button Helper Functions
export const getMediaGalleryToolbarClasses = (
	galleryToolbarView,
	galleryToolbarPlacement,
	isMobile
) => {
	const commonGalleryClasses = ['media-gallery-toolbar', 'd-print-none'];
	const desktopGalleryClasses = [];

	const mobileGalleryClasses = ['mobile-toolbar', 'w-100', 'text-center'];

	if (galleryToolbarView === 'links') {
		desktopGalleryClasses.push('m-4');
		commonGalleryClasses.push('absolute-left');
		mobileGalleryClasses.push('py-1');
		if (galleryToolbarPlacement === 'top-left') {
			commonGalleryClasses.push('absolute-top');
		} else {
			commonGalleryClasses.push('absolute-bottom');
		}
	} else if (galleryToolbarView === 'thumbnails') {
		desktopGalleryClasses.push('my-6');
		if (isMobile) {
			mobileGalleryClasses.push('bg-contrast-med', 'pt-4', 'pb-5');
		}
	}
	return [
		...commonGalleryClasses,
		...(isMobile ? mobileGalleryClasses : desktopGalleryClasses)
	];
};

export const getGalleryContainerClasses = (galleryToolbarView, isMobile) => {
	const commonGalleryContainerClasses = [
		'mobile-toolbar__container',
		'd-flex',
		'justify-content-center'
	];
	const desktopGalleryContainerClasses = [];
	const mobileGalleryContainerClasses = [];

	if (galleryToolbarView === 'links') {
		commonGalleryContainerClasses.push('box', 'p-3', 'align-items-center');
		desktopGalleryContainerClasses.push('box-border');
		mobileGalleryContainerClasses.push('border-0', 'rounded-0');
	} else if (galleryToolbarView === 'thumbnails') {
		commonGalleryContainerClasses.push('align-items-space-between');
	}
	return [
		...commonGalleryContainerClasses,
		...(isMobile
			? mobileGalleryContainerClasses
			: desktopGalleryContainerClasses)
	];
};
